<template>
  <div class="login-view-wrapper">
    <!-- logoin -->
    <div class="login-box">
      <w-login-view :visible="viewType === 'login'" @login="onLogin" @show-password-view="viewType = 'password'" />
      <w-auth-view :visible="viewType === '2factor'" :address="authAddress" @login-view-show="viewType = 'login'" />
      <w-password-view :visible="viewType === 'password'" @login-view-show="viewType = 'login'" />
      <div class="footer">
        <el-tooltip effect="dark" content="Watchall Launcher" placement="top" style="position:absolute">
          <a class="file-icon" :href="`${downloadUrl}LAUNCHER`">
            <div class="launcher"></div>
          </a>
        </el-tooltip>
        <el-tooltip effect="dark" content="Google Chrome" placement="top" style="position:absolute; right: 15%">
          <a class="file-icon" :href="`${downloadUrl}CHROME`">
            <div class="chrome"></div>
          </a>
        </el-tooltip>
      </div>
    </div>
    <!-- copyright -->
    <div class="copyright-wrapper">
      <div class="character-img"></div>
      <div class="text">Copyright © Watchtek Co., Ltd. All Rights Reserved.</div>
    </div>
    <!-- stars -->
    <vue-particles :particles-data="particlesData" style="position: absolute; background: transparent; width: 100%; height: 100%;" />
    <!-- organic shapes -->
    <svg ref="organicWrapper" class="scene" width="100%" height="100vh" viewBox="0 0 1900 1070" preserveAspectRatio="none">
      <defs>
        <linearGradient id="organic-gradient-1" x1="1" x2="1.3" y1="0" y2="0.5">
          <stop class="stop1" offset="10%" />
          <stop class="stop2" offset="40%" />
          <stop class="stop3" offset="70%" />
          <stop class="stop4" offset="100%" />
        </linearGradient>
        <linearGradient id="organic-gradient-2" x1="1" x2="1.3" y1="0" y2="0.5">
          <stop class="stop5" offset="10%" />
          <stop class="stop6" offset="16%" />
          <stop class="stop7" offset="25%" />
        </linearGradient>
      </defs>
      <path
        ref="organicPath1"
        d="M1901.251,111.787c0,0-155.996,31.602-285.556,212.697c0,0-75.16,118.122-182.812,161.316 c0,0-120.847,48-291.293,68.547c0,0-457.127,48.925-468.608,525.444l1228.269,0.771V111.787z"
        pathdata:id="M1901.251,111.787c0,0-155.996,31.602-285.556,220.697c0,0-75.16,118.122-182.780,161.316 c0,0-120.847,48-291.293,68.547c0,0-457.127,48.925-468.608,525.444l1228.269,0.771V111.787z"
      ></path>
      <path
        ref="organicPath2"
        id="organic-path-2"
        d="M1901.256,188.7c0,0-200.451,48.90-300.285,199.595c0,0-84.77,141.663-237.392,157.647c0,0-265.31,0.021-391.016,152.09c0,0-138.215,120.496-130.051,394.946l1062.973,0.484L1901.056,198.8L1901.056,198.8z"
        pathdata:id="M1901.056,198.8c0,0-196.556,41.98-273.743,185.135c0,0-108.813,182.847-298.813,188.847 c0,0-242.649-6.571-360.191,123.351c0,0-149.859,138.849-128.141,394.946l1052.973,10.484L1901.066,198.8L1901.056,198.8z"
      />
      <path
        ref="organicPath3"
        id="organic-path-3"
        d="M1901.171,1081.663l-0.295-767.489c0,0-168.414,47.771-313.121,221.92c0,0-60.869,69.296-186.754,81.749 c-57.215,8.481-286.687-22.138-407.339,155.644c0,0-92.37,120.351-54.89,307.937L1901.181,1081.563z"
        pathdata:id="M1901.146,1081.744l-0.291-737.479c0,0-168.414,3.855-313.124,181.621c0,0-77.873,88.292-203.754,100.703 c-57.215,8.482-269.687,9.138-390.339,163.986c0,0-92.37,120.300-104.89,290.952L1900.186,1088.744z"
      />
      <path
        ref="organicPath4"
        d="M826.297-0.882c-0.509-2.935,59.631,272.472-348.188,342.896c0,0-179.927,26.3-238.147,241.238c0,0-26.173,119.052-238.872,184.395L1.205-1.078L826.297-0.882z"
        pathdata:id="M806.297,0c-0.509-2.935,24.203,228.781-328.482,322.038c0,0-163.800,25.276-221.853,240.14 c0,0-42.173,111.186-254.872,176.529L1.205-1.078L806.297,0z"
      />
    </svg>
  </div>
</template>

<script>
import anime from 'animejs';
import forEach from 'lodash/forEach';
import { baseUrl } from '@/config';
import WLoginView from './components/LoginView';
import WAuthView from './components/AuthView';
import WPasswordView from './components/PasswordView';

export default {
  name: 'WLogin',
  components: {
    WLoginView,
    WAuthView,
    WPasswordView,
  },
  data() {
    return {
      viewType: 'login',
      /**
       * 로드 마스크 표시 여부
       * @type {Boolean}
       */
      loading: false,
      authAddress: '',
      animeTaskName: 'organicAnimeTask',
      animeTask: [],
      particlesData: {
        particles: {
          number: {
            value: 60,
            density: {
              enable: true,
              value_area: 700,
            },
          },
          color: {
            value: '#ffffff',
          },
          shape: {
            type: 'circle',
            polygon: {
              nb_sides: 5,
            },
          },
          opacity: {
            value: 0.4,
            random: false,
            anim: {
              enable: true,
              speed: 0.2,
              opacity_min: 0,
              sync: false,
            },
          },
          size: {
            value: 2,
            random: true,
            anim: {
              enable: true,
              speed: 2,
              size_min: 0,
              sync: false,
            },
          },
          line_linked: {
            enable: false,
            distance: 300,
            color: '#ffffff',
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.2,
            direction: 'none',
            random: true,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 1800,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'bubble',
            },
            onclick: {
              enable: true,
              mode: 'push',
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 83.91608391608392,
              size: 1,
              duration: 3,
              opacity: 1,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      },
    };
  },
  computed: {
    downloadUrl() {
      return `${baseUrl}/login/download-setup-file.do?type=`;
    },
  },
  mounted() {
    this.createOrganicAnime();
  },
  beforeDestroy() {
    this.removeOrganicAnime();
  },
  methods: {
    /**
     * 로그인을 수행한다.
     * @author Ju
     * @param  {[type]} loginData [description]
     */
    onLogin(loginData) {
      if (loginData.twoFactorFlag) {
        this.viewType = '2factor';
        this.$nextTick(() => {
          // update 시점 문제로 인증번호 입력 화면으로 전환이 된 후 authAddress를 설정해야 정상적으로 반영.
          this.authAddress = loginData.userInfo.email;
        });
      } else {
        this.$store.dispatch('setLoginInfo', loginData);
        this.$router.push({
          path: '/',
        });
      }
    },
    /**
     * organic shape에 대한 애니메이션을 생성한다.
     * @author Ju
     */
    createOrganicAnime() {
      const pathTagList = this.$el.querySelectorAll('path');
      forEach(pathTagList, (tag) => {
        anime({
          targets: tag,
          duration: anime.random(3000, 5000),
          easing: 'cubicBezier(.5, .0, .5, 1)',
          d: tag.getAttribute('pathdata:id'),
          loop: true,
          direction: 'alternate',
        });
      });
      this.organicTargets = pathTagList;
    },
    /**
     * organic shape에 대한 애니메이션을 제거한다.
     * @author Ju
     */
    removeOrganicAnime() {
      anime.remove(this.organicTargets);
    },
  },
};
</script>

<style lang="scss">
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: url('../../assets/img/login-background.jpg');
  background-repeat: no-repeat;
  /* background: linear-gradient(#2d2b2c, #333649); */
  background-position: center;

  .login-logo {
    width: 327px;
    height: 79px;
    background-image: url('../../assets/img/temp_applemango_logo.jpg');
    background-position: center;
    // left: 50%;
    // transform: translateX(-50%);
    // position: relative;
    // margin-bottom: 15px;
  }

  .login-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-width: 400px;
    width: auto;
    height: auto;
    padding: 20px 25px 25px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 3px 5px 40px rgba(0, 0, 0, 0.2);

    .header {
      height: 90px;
    }
  }

  .message {
    &-error {
      font-size: 9pt;
      color: #eb395e;
    }

    &-success {
      font-size: 9pt;
      color: #386aac;
    }
  }

  .file-icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

.login-box-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 400px;
  width: auto;
  height: auto;
  padding: 40px 25px 25px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 3px 5px 40px rgba(0, 0, 0, 0.2);
}

// .login-box--input {
//     width: 300px;
// }

.login-box--login-button {
  width: 300px;
  height: 40px;
  margin-top: 20px;
  /* box-shadow: 3px 5px 10px #c5c5c5; */
}

.auth-cmp {
  width: 400px;
}

.plain {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue